import Task from './Task';
import { createError } from '../error';

class CheckinCheckoutTask extends Task {
  constructor($q, APIService, StaffUserService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.StaffUserService = StaffUserService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set staffUserId(id) {
    this._staffUserId = id;
  }

  get staffUserId() {
    return this._staffUserId;
  }

  get lat() {
    return this._lat;
  }
  set lat(val) {
    this._lat = val;
  }

  get lon() {
    return this._lon;
  }
  set lon(val) {
    this._lon = val;
  }

  get timestamp() {
    return this._timestamp;
  }
  set timestamp(val) {
    this._timestamp = val;
  }

  get direction() {
    return this._direction;
  }
  set direction(val) {
    this._direction = val;
  }

  set eventId(id) {
    this._eventId = id;
  }
  get eventId() {
    return this._eventId;
  }

  /**
   * Public methods
   */

  populate(data) {
    this.staffUserId = data.staffUserId;
    this.lat         = data.lat;
    this.lon         = data.lon;
    this.timestamp   = data.timestamp;
    this.direction   = data.direction;
    this.eventId     = data.eventId;
  }

  serialize() {
    return {
      staffUserId: this.staffUserId,
      lat: this.lat,
      lon: this.lon,
      timestamp: this.timestamp,
      direction: this.direction,
      eventId: this.eventId,
    };
  }

  execute() {
    return this.StaffUserService.checkIn( this.eventId, this.direction, this.timestamp, this.lat, this.lon);
  }
}

export default CheckinCheckoutTask;
